<template lang="pug">
  .ajax-checkbox
    .field(v-for="(item, index) in items")
      input.is-checkradio.custom-checkbox(type="checkbox" :id="`checkbox_${item.name}_${index}`" v-model="chosen[index]" :true-value="item")
      label.checkbox(:for="`checkbox_${item.name}_${index}`") {{ item.name }}
</template>

<script>
import { mapGetters } from 'vuex'
import { gettext } from '@/services/TranslateHandler'
const _ = require('lodash')

export default {
  name: 'AjaxCheckbox',
  components: {
  },
  data () {
    return {
      chosen: []
    }
  },
  props: {
    items: {
      default: () => {
        return []
      }
    },
    value: {
      default: () => {
        return []
      }
    }
  },
  methods: {
    gettext: gettext,
    clear () {
      this.chosen = []
    },
    syncData () {
      let result = []
      _.each(this.chosen, item => {
        let ch = _.findIndex(this.items, {'id': (item || {}).id})
        if (item) this.$set(result, ch, this.items[ch])
      })
      this.chosen = result
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  },
  watch: {
    chosen: function (val) {
      this.$emit('input', _.filter(val))
    },
    items: function (val) {
      if (val.length) {
        this.syncData()
        _.each(this.value, (item) => {
          if (typeof item !== 'object') {
            let ch = _.find(val, {'id': parseInt(item)})
            if (ch) {
              this.$set(this.chosen, _.findKey(this.items, ch), ch)
            }
          }
        })
      }
    },
    value: function (val) {
      if (this.items) {
        if (~val) {
          let data = _.isString(val) ? val.split(',') : val
          _.each(data, (item) => {
            if (typeof item !== 'object') {
              let ch = _.find(this.items, {'id': parseInt(item)})
              if (ch) {
                this.$set(this.chosen, _.findKey(this.items, ch), ch)
              }
            }
          })
        } else {
          this.clear()
        }
      }
    }
  },
  created () {
    if (this.value && this.items) {
      _.each(this.value, (item) => {
        if (typeof item !== 'object') {
          let ch = _.find(this.items, {'id': parseInt(item)})
          if (ch) {
            this.$set(this.chosen, _.findKey(this.items, ch), ch)
          }
        }
      })
    }
  }
}
</script>

<style lang='scss'>
  .ajax-checkbox {
    .field {
      margin-bottom: 0.25rem;
      input.custom-checkbox {
        & + label {
          font-weight: normal;
          margin: 0.1rem;
          font-size: 15px;
          &:after {
            border-color: #bb1d2c !important;
          }
        }
        &:hover {
          & + label {
            &:before {
              border-color: #bb1d2c !important;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ajax-checkbox/index.vue